import { memoizeClear } from '@deephaven/grid';
import { vsTriangleDown, vsTriangleRight, vsTriangleUp, vsLinkExternal } from '@deephaven/icons';
var iconMap = new Map([['sortUp', vsTriangleUp], ['sortDown', vsTriangleDown], ['caretDown', vsTriangleDown], ['caretRight', vsTriangleRight], ['cellOverflow', vsLinkExternal]]);
var makeIcon = memoizeClear((name, size) => {
  var faIcon = iconMap.get(name);
  if (faIcon === undefined) {
    throw new Error('Icon is undefined');
  }
  var path = Array.isArray(faIcon.icon[4]) ? faIcon.icon[4][0] : faIcon.icon[4];
  var icon = new Path2D(path);
  var scaledIcon = new Path2D();
  var scaleMatrix = {
    a: size / faIcon.icon[0],
    d: size / faIcon.icon[1]
  };
  scaledIcon.addPath(icon, scaleMatrix);
  return scaledIcon;
}, {
  max: 1000
});
export function getIcon(name, size) {
  return makeIcon(name, size);
}
//# sourceMappingURL=IrisGridIcons.js.map